import axios from 'axios'

interface IConfig {
    [key: string]: string | boolean;
    APP_TITLE: string;
    REST_API: string;
    AUTH_CLIENT_ID: string;
    AUTH_ENDPOINT: string;
    SSU_ENDPOINT: string;
    TOKEN_KEY: string;
    MAX_STUDENTS: string;
    MBC_MFE_REMOTE_URL: string;
    ENABLE_SQE_ADMIN_MFE: boolean;
}

interface JsonFile {
    [key: string]: string;
}

const BOOLEAN_KEYS = new Set<string>(['ENABLE_SQE_ADMIN_MFE'])

let Configuration: IConfig = {} as IConfig

const InitConfiguration = async (): Promise<void> => {
    const response = await axios.get('/config.values.json')
    const configValues: JsonFile = response.status === 404 ? {} : response.data
    const config = {} as IConfig
    for (const value in configValues) {
        const envValue = process.env[`VUE_APP_${value}`]
        const fallback = BOOLEAN_KEYS.has(value) ? envValue === 'true' : envValue
        config[value] = parse(configValues[value], fallback)
    }
    Configuration = config
}

function parse(value: string, fallback: boolean | number | string | undefined) {
    if (typeof value === 'undefined' || value === '') {
        return fallback
    }
    switch (typeof fallback) {
        case 'boolean':
            return !!JSON.parse(value)
        case 'number':
            return JSON.parse(value)
        default:
            return value
    }
}

export { InitConfiguration, Configuration }
